import React from "react";
import { useParams } from "react-router-dom";
import { useWhiteLabelLead } from "@lib/context";
import { AppContext } from "@lib/types/Context";
import { SharedCustomerLeads } from "@app/shared";
import { NoPermission } from "@lib/components/AppComponents";

const CustomerLeadList: React.FC = () => {
  const { leadId } = useParams();
  const { permissions } = useWhiteLabelLead();

  // Check if user has permission to view wallet pool
  if (!permissions.canViewWalletPool) {
    return <NoPermission />;
  }

  return (
    <SharedCustomerLeads context={AppContext.CUSTOMER_LEAD} leadId={leadId} />
  );
};

export default CustomerLeadList;
